/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 *
 */
import styled from 'styled-components';

const SIZE = 32;

interface StyledGoogleMapsControlProps {
  buttonTextColor: string;
  isSmallSize?: boolean;
  topBorder?: boolean;
  bottomBorder?: boolean;
}

const StyledGoogleMapsControl = styled.div`
  color: ${(props: StyledGoogleMapsControlProps) => props.buttonTextColor};
  width: ${SIZE}px;
  height: ${SIZE}px;
  border-bottom: ${(props: StyledGoogleMapsControlProps) => props.bottomBorder ? '1px solid gray' : 'none'};
  border-top: ${(props: StyledGoogleMapsControlProps) => props.topBorder ? '1px solid gray' : 'none'};
  box-sizing: border-box;

  > svg {
    margin: ${(props: StyledGoogleMapsControlProps) => (props.isSmallSize ? '6px' : '4px')};
  }
`;

export default StyledGoogleMapsControl;
